import { render, staticRenderFns } from "./ImageButtonShow.vue?vue&type=template&id=5b7bd65c&scoped=true&"
import script from "./ImageButtonShow.vue?vue&type=script&lang=js&"
export * from "./ImageButtonShow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=5b7bd65c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7bd65c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b7bd65c')) {
      api.createRecord('5b7bd65c', component.options)
    } else {
      api.reload('5b7bd65c', component.options)
    }
    module.hot.accept("./ImageButtonShow.vue?vue&type=template&id=5b7bd65c&scoped=true&", function () {
      api.rerender('5b7bd65c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Buttons/ImageButtonShow.vue"
export default component.exports